module.exports = __webpack_public_path__ + "media/images/quotes-primary-47c282c5be5fe6ebe95304e8a2656b9b.svg";